
(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbSettingsField', fbSettingFieldDirective);

    function fbSettingFieldDirective(lodash, $compile, CommonHelper) {
        return {
            restrict: "EA",
            scope: {
                element: '=',
                fieldType: '@',
                template: '=?',
                eventHandler: '&'
            },
            require: 'ngModel',
            controller: fbSettingFieldDirectiveCtrl,
            controllerAs: 'vm',
            link: fbSettingFieldDirectiveLink
        };

        function fbSettingFieldDirectiveLink(scope, elem, attr, ngModelCtrl) {
            scope.currentModel = {
                modelValue: null,
                settingsEnabled: false,
            };

            var subElementTemplate = CommonHelper.isEmpty(scope.template) ? '' : scope.template;

            var template = '<div class="fb-settings-field"><div><fb-field-checkbox-button element="element" model="currentModel.settingsEnabled" ></fb-field-checkbox-button></div><div>' +
                '<fb-label element="element">' +
                '<fb-' + scope.fieldType + ' element="element" options="element.options" model="currentModel.modelValue" class="field-element" event-handler="eventHandler(fieldType)" ' + subElementTemplate
                + ' ng-if="currentModel.settingsEnabled"></fb-' + scope.fieldType + '>' +
                '</fb-label>' +
                '</div></div>';

            elem.html(template);
            var cloneElement = $compile(elem.contents())(scope);
            scope.$on('$destroy', function() {
                cloneElement.off();
            });

            ngModelCtrl.$formatters.push(function(modelValue) {
                var _modelValue = modelValue.value || lodash.get(scope.element, 'options.settings_type.default.value', null);
                var _settingsEnabled = modelValue.toggle || lodash.get(scope.element, 'options.settings_type.default.toggle', false);
                return {
                    value: _modelValue,
                    toggle: _settingsEnabled,
                };
            });



            ngModelCtrl.$render = function() {
                scope.currentModel.modelValue   = ngModelCtrl.$viewValue.value;
                scope.currentModel.settingsEnabled = ngModelCtrl.$viewValue.toggle;
                // setViewValue();
            };


            scope.$watch(function() {
                return scope.currentModel.modelValue;
            }, function() {
                setViewValue();
            });

            scope.$watch(function() {
                return scope.currentModel.settingsEnabled;
            }, function() {
                setViewValue();
            });

            scope.handleToggleChange = function() {
                setViewValue();
            };

            function setViewValue() {
                ngModelCtrl.$setViewValue({
                   toggle: scope.currentModel.settingsEnabled,
                   value: scope.currentModel.modelValue,
                });
            }
        }
    }

    function fbSettingFieldDirectiveCtrl($scope) {
        var vm = this;
        this.$onInit = function() {
            vm.formIdentifier = $scope.$parent.vm.formIdentifier;
            vm.elementIdentifier = $scope.$parent.vm.elementIdentifier;
        }
    }
})();
